import { render, staticRenderFns } from "./InformacionPaciente.vue?vue&type=template&id=1d6fe419&scoped=true"
import script from "./InformacionPaciente.vue?vue&type=script&lang=ts"
export * from "./InformacionPaciente.vue?vue&type=script&lang=ts"
import style0 from "./InformacionPaciente.vue?vue&type=style&index=0&id=1d6fe419&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6fe419",
  null
  
)

export default component.exports